import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" ref={ref} {...props}><path fill="#32325D" d="M10.273 4.94L9.333 4 5.333 8 9.333 12 10.273 11.06 7.22 8z" transform="matrix(0 1 1 0 -.197 .197)" /></svg>;
const ForwardRef = forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/k_Connect_service_dev_qa-release/src/images/arrow-up.svg?url";
export default __svgUrl;
